export default __webpack_public_path__ + "static/media/img_header.5ba15fe4.svg";